import { AnyAction } from "redux";
import {
  FETCH_SERVICES_PAGE_ERROR,
  FETCH_SERVICES_PAGE_SUCCESS,
  REQUEST_FETCH_SERVICES_PAGE,
} from "redux/actions/pages/services";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_SERVICES_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SERVICES_PAGE_SUCCESS:
      return {
        data: action.services,
        error: null,
        loading: false,
      };
    case FETCH_SERVICES_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
